export default "__VITE_ASSET__C2IJSHDd__"